import base64 from '../global/base64.js';
import md5 from '../global/md5.js';
import store from '@/store/index.js';
import timeHelper from '../global/timeHelper.js';
import axios from 'axios';
import api from '../api.js'


const fSmApiReq = async ({
	sReqUrl,
	sApiName,
	sMethodName,
	sReqJsonStr,
	sApiUserPhone,
	sApiUserId,
	sApiReqFrom,
	sApiReqToken,
	sApiRandomStr,
  sOrgSk
}) => {
	// let sReqTime = timeHelper.fGetNowTime(2);
	// // 请求参数BASE64
	// let sReqJsonBase64 = Base64.encode(sReqJsonStr);


	//       // 验签秘钥
	let  orgSk = sOrgSk || 'S1Rtxp2EyZXcHMThJYZdH0y8DM3NWE6R';

	//       sWaitSign := sOrgSk + rApiReq.REQ_JSON + rApiReq.REQ_TIME + sOrgSk;
	//       sSign := THashMD5.GetHashString(sWaitSign).ToLower;



	let sReqTime = timeHelper.fGetNowTime(2);
	// 请求参数BASE64
	let sReqJsonBase64 = Base64.encode(sReqJsonStr);

	let sApiReqSign = orgSk + sReqJsonBase64 + sReqTime + orgSk;
	sApiReqSign = md5(sApiReqSign);
	sApiReqSign = sApiReqSign.toLowerCase();

	let js = {};
	js['METHOD_NAME'] = sMethodName;
	js['REQ_JSON'] = sReqJsonBase64;
	js['MCH_ID'] = sApiUserPhone;
	js['USER_ID'] = sApiUserId || '1001';
	js['REQ_IP'] = '127.0.0.1';
	js['REQ_FROM'] = sApiReqFrom;
	js['REQ_VER'] = 'smSellAdmin';
	js['REQ_TIME'] = sReqTime;
  js['ORG_AK'] = 'smBoxAst'
  js['REQ_SIGN'] = sApiReqSign
	js['REQ_TOKEN'] = sApiReqToken || store.state.mSmUnionPlatformOrg.token;

	let res = await axios.post(sReqUrl, js);
	if (res.result != 'sucess' && res.msg == 'tokenFail') {
		window.location.replace('http://soft.sanmipos.com/smSell/index.html#/pages/login/login')
		return
		// {
		// 	// data: {
		// 	result: 'fail',
		// 	msg: '请重新登录1'
		// 	// }
		// }
	}
	return res;
};



const fPostToAdminApi = (obj) => {
	let sReqUrl;
	sReqUrl = store.state.mSmUnionPlatformOrg.srvUrl + 's/smSellAdmin/adminApi' //
	return fSmApiReq({
		sReqUrl,
		sMethodName: obj.sMethodName,
		sReqJsonStr: JSON.stringify(obj.reqJson),
		sApiUserPhone: store.state.mSmUnionPlatformOrg.phoneNo,
		sApiUserId: store.state.mSmUnionPlatformOrg.userId,
		sApiReqFrom: 'WEB',
		sApiRandomStr: obj.sApiRandomStr,
	});
};
const fPostToQuery = (obj) => {
	let sReqUrl;
	sReqUrl = store.state.mSmUnionPlatformOrg.srvUrl + 's/smSellQuery/queryApi'
	return fSmApiReq({
		sReqUrl,
		sMethodName: obj.sMethodName,
		sReqJsonStr: JSON.stringify(obj.reqJson),
		sApiUserPhone: store.state.mSmUnionPlatformOrg.phoneNo,
		sApiUserId: store.state.mSmUnionPlatformOrg.userId,
		sApiReqFrom: 'WEB',
		sApiRandomStr: obj.sApiRandomStr,
	});
};

const fPostToSmUnionQuery = (obj) => {
	let sReqUrl;
  sReqUrl = "https://sanmipos.com/smPayMains/smUnionQuery/queryApi"
	return fSmApiReq({
		sReqUrl,
		sMethodName: obj.sMethodName,
		sReqJsonStr: JSON.stringify(obj.reqJson),
		sApiUserPhone: store.state.mSmUnionPlatformOrg.phoneNo,
		sApiUserId: store.state.mSmUnionPlatformOrg.userId,
		sApiReqFrom: 'WEB',
		sApiRandomStr: obj.sApiRandomStr,
	});
};

const fPostToSmBoxShopApi = (obj) => {
  let sReqUrl = obj.reqUrl + "s/smDuty/dutyApi"
  return fSmApiReq({
    sReqUrl,
    sMethodName: obj.sMethodName,
    sReqJsonStr: JSON.stringify(obj.reqJson),
    sApiUserPhone: obj.sApiUserPhone || store.state.mSmUnionPlatformOrg.phoneNo,
    sApiUserId: store.state.mSmUnionPlatformOrg.userId,
    sApiReqFrom: 'WEB',
    sApiRandomStr: obj.sApiRandomStr
  });
};
export default {
	fPostToAdminApi,
	fPostToQuery,
	fPostToSmUnionQuery,
  fPostToSmBoxShopApi
}



//////////////////
// WEBPACK FOOTER
// ./common/api/newSmApi.js
// module id = null
// module chunks = 